"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBondTransactionsFromSignatures = exports.getBondEventsBySignatures = exports.getBondEvents = void 0;
const types_1 = require("../types");
const cartManagerV2_1 = require("./cartManagerV2");
const getBondEvents = ({ programId, fromThisSignature, eventslimit, signaturesLimit, untilThisSignature, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
    const LIMIT = !eventslimit || eventslimit > 100 ? 100 : eventslimit;
    const limitSig = !signaturesLimit ? 1e10 : signaturesLimit;
    let allSignaturesInfos = [];
    const currentLastSignatureInfo = (yield connection.getConfirmedSignaturesForAddress2(programId, {
        limit: 1,
    }, 'confirmed'))[0];
    let currentLastSignature = fromThisSignature || currentLastSignatureInfo.signature;
    if (currentLastSignature == untilThisSignature)
        return [];
    let newSignatureInfosLatestToPast = yield connection.getConfirmedSignaturesForAddress2(programId, {
        limit: LIMIT,
        before: currentLastSignature,
        until: untilThisSignature,
    }, 'confirmed');
    if (newSignatureInfosLatestToPast.length == 0)
        return [];
    currentLastSignature = newSignatureInfosLatestToPast[newSignatureInfosLatestToPast.length - 1].signature;
    allSignaturesInfos = [...allSignaturesInfos, ...newSignatureInfosLatestToPast, currentLastSignatureInfo].filter((signatureInfo) => !signatureInfo.err);
    while (newSignatureInfosLatestToPast.length === LIMIT &&
        (!eventslimit || allSignaturesInfos.length >= eventslimit) &&
        allSignaturesInfos.length < limitSig) {
        newSignatureInfosLatestToPast = yield connection.getConfirmedSignaturesForAddress2(programId, {
            limit: LIMIT,
            before: currentLastSignature,
            until: untilThisSignature,
        }, 'confirmed');
        currentLastSignature = newSignatureInfosLatestToPast[newSignatureInfosLatestToPast.length - 1].signature;
        allSignaturesInfos = [...allSignaturesInfos, ...newSignatureInfosLatestToPast].filter((signatureInfo) => !signatureInfo.err);
    }
    const bondTransactions = yield (0, exports.getBondTransactionsFromSignatures)({
        signatures: allSignaturesInfos.map((signatureInfo) => signatureInfo.signature),
        connection,
    });
    let allBondEvents = [];
    for (let bondTxn of bondTransactions) {
        const bondEvents = yield parseTransactionInfoToBondEvents({ bondTxn, connection });
        allBondEvents = [...allBondEvents, ...bondEvents];
    }
    return allBondEvents;
});
exports.getBondEvents = getBondEvents;
const getBondEventsBySignatures = ({ signatures, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
    const bondTransactions = yield (0, exports.getBondTransactionsFromSignatures)({
        signatures,
        connection,
    });
    let allbondEvents = [];
    for (let bondTxn of bondTransactions) {
        const bondEvents = yield parseTransactionInfoToBondEvents({ bondTxn, connection });
        allbondEvents = [...allbondEvents, ...bondEvents];
    }
    return allbondEvents;
});
exports.getBondEventsBySignatures = getBondEventsBySignatures;
const getBondTransactionsFromSignatures = ({ signatures, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
    const bondTransactions = [];
    for (let signature of signatures) {
        const currentTransactionInfo = yield connection.getParsedTransaction(signature, {
            commitment: 'confirmed',
            maxSupportedTransactionVersion: 0,
        });
        if (!currentTransactionInfo || !isBondTransactionInfo(currentTransactionInfo))
            continue;
        bondTransactions.push(currentTransactionInfo);
    }
    return bondTransactions;
});
exports.getBondTransactionsFromSignatures = getBondTransactionsFromSignatures;
const isBondTransactionInfo = (currentTransactionInfo) => {
    var _a, _b;
    return ((_b = (_a = currentTransactionInfo.meta) === null || _a === void 0 ? void 0 : _a.logMessages) === null || _b === void 0 ? void 0 : _b.find(isBondInstructionLog)) !== undefined;
};
const getNumberValueFromLog = (logMessages, eventLog) => {
    const newBorrowedSolLog = logMessages.find((log) => log.startsWith(eventLog));
    return Number(newBorrowedSolLog === null || newBorrowedSolLog === void 0 ? void 0 : newBorrowedSolLog.replace(eventLog, ''));
};
const parseTransactionInfoToBondEvents = ({ bondTxn, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const instructionLogs = (_b = (_a = bondTxn.meta) === null || _a === void 0 ? void 0 : _a.logMessages) === null || _b === void 0 ? void 0 : _b.reduce((instructionLogs, log) => (isBondInstructionLog(log) ? [...instructionLogs, log] : instructionLogs), []);
    const programInstructionsRaw = bondTxn.transaction.message.instructions;
    const innerInstructions = (_c = bondTxn.meta) === null || _c === void 0 ? void 0 : _c.innerInstructions;
    const programInstructions = programInstructionsRaw;
    let bondEvents = [];
    for (let i = 0; i < innerInstructions.length; i++) {
        const currentLog = instructionLogs[i];
        if (!isBondInstructionLog(currentLog))
            continue;
        const currentSignature = bondTxn.transaction.signatures[0];
        const currentInnerInstruction = innerInstructions[i];
        const currentProgramInstruction = programInstructions[i].accounts.length == 0 ? programInstructions[i + 1] : programInstructions[i];
        const blockTime = bondTxn.blockTime;
        if (!BOND_TRANSACTION_PARSERS[currentLog])
            continue;
        const parsedBondEvents = yield BOND_TRANSACTION_PARSERS[currentLog]({
            innerInstruction: currentInnerInstruction,
            programInstruction: currentProgramInstruction.accounts.length == 0 ? programInstructions[i + 2] : currentProgramInstruction,
            signature: currentSignature,
            transaction: bondTxn,
            blockTime,
            connection,
        });
        if (!parsedBondEvents)
            continue;
        bondEvents = [...bondEvents, ...parsedBondEvents];
    }
    return bondEvents;
});
const isBondInstructionLog = (log) => Object.values(BondInstruction).includes(log);
const isInstructionLog = (log) => log.startsWith('Program log: Instruction:');
var BondInstruction;
(function (BondInstruction) {
    BondInstruction["RepayFbondToTradeTransactions"] = "Program log: Instruction: RepayFbondToTradeTransactions";
    BondInstruction["CreateBondAndSellToOffers"] = "Program log: Instruction: CreateBondAndSellToOffers";
    BondInstruction["RefinanceToBondOffersV2"] = "Program log: Instruction: RefinanceToBondOffersV2";
    BondInstruction["LiquidateBondOnAuction"] = "Program log: Instruction: LiquidateBondOnAuction";
    BondInstruction["ClaimNftByLenderPnft"] = "Program log: Instruction: ClaimNftByLenderPnft";
})(BondInstruction || (BondInstruction = {}));
const BOND_TRANSACTION_PARSERS = {
    [BondInstruction.RepayFbondToTradeTransactions]: ({ innerInstruction, programInstruction, signature, blockTime, transaction, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
        const user = programInstruction.accounts[7];
        const solAmount = getTransferAmountFromInnerInstructions(innerInstruction);
        const fbond = programInstruction.accounts[1];
        return [
            {
                timestamp: blockTime,
                signature: signature,
                bondEventType: types_1.BondEventType.Repay,
                fbond: fbond ? fbond.toBase58() : '',
                user: user ? user.toBase58() : '',
                solAmount: solAmount,
                bondsAmount: solAmount / cartManagerV2_1.BOND_DECIMAL_DELTA,
            },
        ];
    }),
    [BondInstruction.CreateBondAndSellToOffers]: ({ innerInstruction, programInstruction, signature, blockTime, transaction, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
        var _d, _e, _f, _g, _h;
        const balanceChanges = (_d = transaction.meta) === null || _d === void 0 ? void 0 : _d.preBalances.map((prebalance, index) => { var _a; return Math.abs(prebalance - (((_a = transaction.meta) === null || _a === void 0 ? void 0 : _a.postBalances[index]) || 0)); });
        // const bondsAmount = Number(
        //   (innerInstruction.instructions.find((ix) => (ix as any)?.parsed?.type == 'mintTo') as any)?.parsed?.info?.amount,
        // );
        const eventCreationLogAmountOfSolBorrowed = 'Program log: Event Creation amountOfBorrowedSol: ';
        const solAmountLog = (_f = (_e = transaction.meta) === null || _e === void 0 ? void 0 : _e.logMessages) === null || _f === void 0 ? void 0 : _f.find((log) => log.startsWith(eventCreationLogAmountOfSolBorrowed));
        const solAmountFromLog = Number(solAmountLog === null || solAmountLog === void 0 ? void 0 : solAmountLog.replace(eventCreationLogAmountOfSolBorrowed, ''));
        const solAmount = solAmountFromLog || (balanceChanges ? balanceChanges[0] : 0);
        const eventCreationLogAmountOfBonds = 'Program log: Event Creation amountOfBondToIssue: ';
        const bondsAmountLog = (_h = (_g = transaction.meta) === null || _g === void 0 ? void 0 : _g.logMessages) === null || _h === void 0 ? void 0 : _h.find((log) => log.startsWith(eventCreationLogAmountOfBonds));
        const bondsAmount = Number(bondsAmountLog === null || bondsAmountLog === void 0 ? void 0 : bondsAmountLog.replace(eventCreationLogAmountOfBonds, ''));
        const user = programInstruction.accounts[2];
        const fbond = programInstruction.accounts[0];
        return [
            {
                timestamp: blockTime,
                signature: signature,
                bondEventType: types_1.BondEventType.Creation,
                fbond: fbond ? fbond.toBase58() : '',
                user: user ? user.toBase58() : '',
                solAmount: solAmount,
                bondsAmount: bondsAmount,
            },
        ];
    }),
    [BondInstruction.RefinanceToBondOffersV2]: ({ innerInstruction, programInstruction, signature, blockTime, transaction, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
        var _j, _k, _l;
        const user = programInstruction.accounts[7];
        const fbondRepay = programInstruction.accounts[1];
        const eventRefinanceRepayLogAmount = 'Program log: Event Refinance fbond.amount_to_return: ';
        const repayAmount = getNumberValueFromLog(((_j = transaction.meta) === null || _j === void 0 ? void 0 : _j.logMessages) || [], eventRefinanceRepayLogAmount);
        const repayEvent = {
            timestamp: blockTime,
            signature: signature,
            bondEventType: types_1.BondEventType.Repay,
            fbond: fbondRepay ? fbondRepay.toBase58() : '',
            user: user ? user.toBase58() : '',
            solAmount: repayAmount,
            bondsAmount: repayAmount / cartManagerV2_1.BOND_DECIMAL_DELTA || 0,
        };
        const fbondCreate = programInstruction.accounts[11];
        const eventRefinanceNewBorrowedSol = 'Program log: Event Refinance new_borrowed_sol_sum: ';
        const newBorrowedSol = getNumberValueFromLog(((_k = transaction.meta) === null || _k === void 0 ? void 0 : _k.logMessages) || [], eventRefinanceNewBorrowedSol);
        const eventRefinanceNewBorrowedBonds = 'Program log: Event Refinance new_borrowed_bonds_sum: ';
        const newBorrowedBonds = getNumberValueFromLog(((_l = transaction.meta) === null || _l === void 0 ? void 0 : _l.logMessages) || [], eventRefinanceNewBorrowedBonds);
        const creationEvent = {
            timestamp: blockTime,
            signature: signature,
            bondEventType: types_1.BondEventType.Creation,
            fbond: fbondCreate ? fbondCreate.toBase58() : '',
            user: user ? user.toBase58() : '',
            solAmount: newBorrowedSol,
            bondsAmount: newBorrowedBonds,
        };
        return [repayEvent, creationEvent];
    }),
    [BondInstruction.LiquidateBondOnAuction]: ({ innerInstruction, programInstruction, signature, blockTime, transaction, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
        // const solAmount = getTransferAmountFromInnerInstructions(innerInstruction);
        var _m, _o;
        const eventLiquidateLogSolAmount = 'Program log: Event Liquidation buyout_price: ';
        const solAmount = getNumberValueFromLog(((_m = transaction.meta) === null || _m === void 0 ? void 0 : _m.logMessages) || [], eventLiquidateLogSolAmount);
        const eventLiquidateLogBondsAmount = 'Program log: Event Liquidation fbond.fbond_token_supply: ';
        const bondsAmount = getNumberValueFromLog(((_o = transaction.meta) === null || _o === void 0 ? void 0 : _o.logMessages) || [], eventLiquidateLogBondsAmount);
        const bondEventType = types_1.BondEventType.Liquidated;
        const user = programInstruction.accounts[7];
        const fbond = programInstruction.accounts[1];
        return [
            {
                timestamp: blockTime,
                signature: signature,
                bondEventType: bondEventType,
                fbond: fbond ? fbond.toBase58() : '',
                user: user ? user.toBase58() : '',
                solAmount: solAmount,
                bondsAmount: bondsAmount,
            },
        ];
    }),
    [BondInstruction.ClaimNftByLenderPnft]: ({ innerInstruction, programInstruction, signature, blockTime, transaction, connection, }) => __awaiter(void 0, void 0, void 0, function* () {
        // const solAmount = getTransferAmountFromInnerInstructions(innerInstruction);
        var _p;
        // const eventRefinanceLiquidateLogSolAmount = 'Program log: Event Liquidation buyout_price: ';
        // const solAmount = getNumberValueFromLog(transaction.meta?.logMessages || [], eventRefinanceLiquidateLogSolAmount);
        const eventLiquidateLogBondsAmount = 'Program log: Event Liquidation bond_trade_transaction.amount_of_bonds: ';
        const bondsAmount = getNumberValueFromLog(((_p = transaction.meta) === null || _p === void 0 ? void 0 : _p.logMessages) || [], eventLiquidateLogBondsAmount);
        const bondEventType = types_1.BondEventType.Liquidated;
        const user = programInstruction.accounts[9];
        const nft = programInstruction.accounts[7];
        const fbond = programInstruction.accounts[1];
        return [
            {
                timestamp: blockTime,
                signature: signature,
                bondEventType: bondEventType,
                fbond: fbond ? fbond.toBase58() : '',
                user: user ? user.toBase58() : '',
                nft: nft ? nft.toBase58() : '',
                solAmount: null,
                bondsAmount: bondsAmount,
            },
        ];
    }),
};
const getTransferAmountFromInnerInstructions = (innerInstruction) => {
    return innerInstruction.instructions
        .filter((instruction) => instruction.program === InnerProgramTypes.System)
        .filter((instruction) => instruction.parsed.type === InnerInstructionTypes.Transfer)
        .reduce((amount, instruction) => {
        return amount + instruction.parsed.info.lamports;
    }, 0);
};
const getTransferAmountFromInnerInstructionsWithoutFee = (innerInstruction) => {
    // console.log(
    //   'transfer ix: ',
    //   innerInstruction.instructions
    //     .filter((instruction) => (instruction as any).program === InnerProgramTypes.System)
    //     .filter((instruction: any) => instruction.parsed.type === InnerInstructionTypes.Transfer)
    //     .slice(0, 1)
    //     .map((ix: any) => ix.parsed.info),
    // );
    return innerInstruction.instructions
        .filter((instruction) => instruction.program === InnerProgramTypes.System)
        .filter((instruction) => instruction.parsed.type === InnerInstructionTypes.Transfer)
        .slice(0, 1)
        .reduce((amount, instruction) => {
        return Math.max(amount + instruction.parsed.info.lamports);
    }, 0);
};
const getFbondAndUserAccountsFromInnerInstructionsDepositReturnedSol = (innerInstruction) => {
    const filteredInstructions = innerInstruction.instructions
        .filter((instruction) => instruction.programId.toString() == '4tdmkuY6EStxbS6Y8s5ueznL3VPMSugrvQuDeAHGZhSt')
        .filter((instruction) => instruction.accounts.length == 4);
    const instruction = filteredInstructions[0];
    const solAmount = getTransferAmountFromInnerInstructions(innerInstruction) / 2;
    return [instruction.accounts[2], instruction.accounts[0], solAmount];
};
var InnerProgramTypes;
(function (InnerProgramTypes) {
    InnerProgramTypes["System"] = "system";
    InnerProgramTypes["SplToken"] = "spl-token";
})(InnerProgramTypes || (InnerProgramTypes = {}));
var InnerInstructionTypes;
(function (InnerInstructionTypes) {
    InnerInstructionTypes["Transfer"] = "transfer";
})(InnerInstructionTypes || (InnerInstructionTypes = {}));
